import { useState, useEffect } from "react";
import * as masterAction from "../../../redux/store/investment-opportunity/investment-master.store";
import * as investorAction from "../../../redux/store/investor/investor.store";

const { InvestmentMasterKind } = masterAction;

const getContent = (promise) =>
  promise.then((res) => (res && res.content) || []).catch(() => []);

/**
 * Lấy dữ liệu cho các dropdown của dự án.
 * Danh mục/trạng thái/hình thức trả cả bản ghi isActive = false; nơi dùng tự lọc.
 * Chủ đầu tư lấy từ api/admin/Investor/GetLookup có sẵn.
 */
const useInvestmentLookups = () => {
  const [lookups, setLookups] = useState({
    categories: [],
    statuses: [],
    types: [],
    investors: [],
    isLoaded: false,
  });

  useEffect(() => {
    let isMounted = true;
    Promise.all([
      getContent(masterAction.GetListMaster(InvestmentMasterKind.Category)),
      getContent(masterAction.GetListMaster(InvestmentMasterKind.Status)),
      getContent(masterAction.GetListMaster(InvestmentMasterKind.Type)),
      getContent(investorAction.GetLookupInvestor()),
    ]).then(([categories, statuses, types, investors]) => {
      isMounted &&
        setLookups({ categories, statuses, types, investors, isLoaded: true });
    });
    return () => {
      isMounted = false;
    };
  }, []);

  return lookups;
};

export default useInvestmentLookups;
